import { ChangeEvent, FC } from 'react';

import {
  Grid,
  MenuItem,
  Pagination,
  Select,
  SelectChangeEvent,
  SxProps,
  Theme,
  Typography
} from '@mui/material';

import { useUrlParams } from 'shared/hooks/useUrlParams';

interface IProps {
  total: number;
  pageSize: number;
  setPageSize: React.Dispatch<React.SetStateAction<number>>;
}

export const TablePagination: FC<IProps> = ({ total, pageSize, setPageSize }) => {
  const { paramsObj, setParam } = useUrlParams();
  const page = paramsObj.page ? parseInt(paramsObj.page) : 1;

  const handlePageSizeChange = (event: SelectChangeEvent<number>) => {
    setParam('page', '1');
    setPageSize(event.target.value as number);
  };

  const handlePageChange = (event: ChangeEvent<unknown>, page: number) => {
    setParam('page', page.toString());
  };

  return (
    <Grid
      container
      justifyContent={'space-between'}
      alignItems={'center'}
      sx={{
        ...customStyles
      }}>
      <Grid>
        <Grid container justifyContent='center' alignItems='center' gap='12px' height={1}>
          <Typography variant='body1'>Show result</Typography>
          <Select name='page-size' id='page-size' onChange={handlePageSizeChange} value={pageSize}>
            <MenuItem disableRipple value={10}>
              10
            </MenuItem>
            <MenuItem disableRipple value={20}>
              20
            </MenuItem>
            <MenuItem disableRipple value={40}>
              40
            </MenuItem>
          </Select>
        </Grid>
      </Grid>
      <Grid>
        <Pagination
          count={Math.max(1, Math.ceil(total / pageSize))}
          onChange={handlePageChange}
          page={page}
          size='large'
        />
      </Grid>
    </Grid>
  );
};

const customStyles = {
  padding: '18px 24px',
  borderRadius: '16px',
  backgroundColor: 'var(--mui-palette-background-paper)',
  '.MuiTypography-root': {
    fontSize: 14,
    lineHeight: '20px',
    color: 'var(--mui-palette-text-primary)'
  },
  '.MuiSelect-select': {
    padding: '6px 14px !important',
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '20px',
    letterSpacing: '0.035px'
  },
  '.MuiSelect-icon': {
    right: '14px'
  },
  '.MuiOutlinedInput-notchedOutline': {
    borderColor: 'var(--mui-palette-pagination-pageSizeBorder)'
  },
  '.MuiInputBase-root': {
    borderRadius: '28px',
    minWidth: '91px',
    p: '0',
    '&:hover': {
      '.MuiOutlinedInput-notchedOutline': {
        borderColor: 'var(--mui-palette-pagination-pageSizeBorder)',
        borderWidth: '2px'
      }
    }
  }
} as SxProps<Theme>;
